/**
 * Which statuses screen 08 may offer (doc 10 C2). Mirrors the server's table
 * (app/domain/appointments.py, doc 03 §3); the server stays the authority and
 * answers 409 INVALID_TRANSITION to anything else.
 */
import type { AppointmentStatus } from '../types';

const ALLOWED: Record<AppointmentStatus, AppointmentStatus[]> = {
  booked: ['confirmed', 'cancelled', 'completed', 'no_show'],
  confirmed: ['cancelled', 'completed', 'no_show'],
  completed: [],
  cancelled: [],
  no_show: [],
};

export function allowedNext(current: AppointmentStatus, startsAt: string, now: Date): AppointmentStatus[] {
  const moves = ALLOWED[current];
  return now.getTime() >= Date.parse(startsAt) ? moves.filter((s) => s !== 'cancelled') : moves;
}
